import module from 'module';

const templateUrl = require('./validator.template.html');
module.component('validator', {
  templateUrl,
  bindings: {
    condition: '<'
  },
  controller: function () {
  }
});
